/* eslint-env jest */
import {
  freeMagnetsBadge, freeMagnetsRow, isMagnetsOption, magnetsOptionLabel, FREE_MAGNETS_BADGE,
  freeItemBadge, freeItemRow, freeItemThumbnail,
} from './packageCardOffer';

const magnets = { couponType: 'FREE_MAGNETS_WITH_FREE_SHIPPING', value: 0, expiresOn: '2026-10-24' };
const pct = { couponType: 'PERCENTAGE_WITH_FREE_SHIPPING', value: 20, expiresOn: '2026-10-24' };

describe('package card — free magnets tier (issue #5218)', () => {
  it('shows the badge only while the magnet tier is live', () => {
    expect(freeMagnetsBadge(magnets)).toBe(FREE_MAGNETS_BADGE);
    expect(freeMagnetsBadge(pct)).toBeNull();
    expect(freeMagnetsBadge(null)).toBeNull();
  });

  it('appends the checklist row with the deadline', () => {
    expect(freeMagnetsRow(magnets)).toBe('(2) FREE Photo Magnets — offer ends Saturday, October 24');
    expect(freeMagnetsRow({ ...magnets, expiresOn: null })).toBe('(2) FREE Photo Magnets');
    expect(freeMagnetsRow(pct)).toBeNull();
    expect(freeMagnetsRow(undefined)).toBeNull();
  });

  it('labels the a-la-carte Magnets option FREE with any package only while live', () => {
    expect(isMagnetsOption({ name: 'Magnets' })).toBe(true);
    expect(isMagnetsOption({ name: 'Photo Magnets' })).toBe(true);
    expect(isMagnetsOption({ name: 'Star Student' })).toBe(false);
    expect(magnetsOptionLabel({ name: 'Magnets' }, magnets)).toBe('FREE with any package');
    expect(magnetsOptionLabel({ name: 'Magnets' }, pct)).toBeNull();
    expect(magnetsOptionLabel({ name: 'Star Student' }, magnets)).toBeNull();
    expect(magnetsOptionLabel(null, magnets)).toBeNull();
  });
});

describe('package card — free item of your choice (#5747)', () => {
  const freeItem = {
    couponType: 'FREE_ADDON_CHOICE',
    value: 0,
    expiresOn: '2026-10-25',
    freeAddons: [
      { id: 160, name: 'Weekly Dry Erase Magnet - School', giftCategory: 'magnets', imageUrl: '/missing.png', priceWith: 29.95 },
      { id: 161, name: 'Weekly Dry Erase Magnet - Groovy', giftCategory: 'magnets', imageUrl: 'https://cdn/groovy.png', priceWith: 29.95 },
    ],
  };

  it('shows the badge, named from the category, only while the offer is live', () => {
    expect(freeItemBadge(freeItem)).toBe('+ FREE MAGNET');
    expect(freeItemBadge(pct)).toBeNull();
    expect(freeItemBadge({ ...freeItem, freeAddons: [] })).toBeNull();
  });

  it('appends the row: the item with package, no design count, no deadline', () => {
    expect(freeItemRow(freeItem)).toBe('Includes a FREE Weekly Dry Erase Magnet with package');
    expect(freeItemRow({ ...freeItem, freeItemLabel: 'dry erase magnet' })).toBe('Includes a FREE dry erase magnet with package');
    expect(freeItemRow(magnets)).toBeNull();
  });

  it('picks the first add-on WITH product art for the thumbnail, or none', () => {
    expect(freeItemThumbnail(freeItem)).toMatchObject({
      src: 'https://cdn/groovy.png', alt: 'Weekly Dry Erase Magnet - Groovy', value: 29.95, pose: null,
    });
    expect(freeItemThumbnail({ ...freeItem, freeAddons: [{ ...freeItem.freeAddons[1], priceWith: null }] }).value).toBeNull();
    expect(freeItemThumbnail({ ...freeItem, freeAddons: [freeItem.freeAddons[0]] })).toBeNull();
    expect(freeItemThumbnail(pct)).toBeNull();
  });
});

describe('package card — which free item to picture, and with which photo (2026-10-22)', () => {
  const addon = (id, giftCategory, overrides = {}) => ({
    id, name: `Item ${id}`, giftCategory, imageUrl: `https://cdn/${id}.png`, priceWith: 29.95, ...overrides,
  });
  // A senior shelf leads with announcements, then gifts, then magnets.
  const set = {
    couponType: 'FREE_ADDON_CHOICE',
    freeAddons: [addon('mag', 'magnets'), addon('cup', 'gifts'), addon('ann', 'announcements')],
  };
  const png = {
    id: 'p1', imageUrl: 'https://cdn/p1.png', watermarkUrl: 'https://cdn/p1w.png', extension: '.png',
  };

  it('pictures the most popular add-on for the order type, with the first photo it can hold', () => {
    const thumb = freeItemThumbnail(set, { orderType: 'senior', poses: [png] });
    expect(thumb.addon.id).toBe('ann');
    expect(thumb.pose).toBe(png);
    expect(thumb.src).toBe('https://cdn/ann.png');
    // A picture-day shelf leads with gifts.
    expect(freeItemThumbnail(set, { orderType: 'school', poses: [png] }).addon.id).toBe('cup');
  });

  it('with no order type known, keeps the server order (the gifts shelf position)', () => {
    expect(freeItemThumbnail(set, { poses: [png] }).addon.id).toBe('mag');
    expect(freeItemThumbnail(set).addon.id).toBe('mag');
  });

  it('passes over a popular design this child has no usable photo for, to the next that has', () => {
    const jpg = { id: 'j1', imageUrl: 'https://cdn/j1.jpg', extension: '.jpg' };
    const refusesJpg = {
      ...set,
      freeAddons: [addon('ann', 'announcements', { allowsJpgPoses: false }), addon('cup', 'gifts', { allowsJpgPoses: true })],
    };
    const thumb = freeItemThumbnail(refusesJpg, { orderType: 'senior', poses: [jpg] });
    expect(thumb.addon.id).toBe('cup');
    expect(thumb.pose).toBe(jpg);
  });

  it('falls back to the most popular one\'s plain product photo when no design can hold any photo', () => {
    const jpg = { id: 'j1', imageUrl: 'https://cdn/j1.jpg', extension: '.jpg' };
    const allRefuse = { ...set, freeAddons: set.freeAddons.map((a) => ({ ...a, allowsJpgPoses: false })) };
    const thumb = freeItemThumbnail(allRefuse, { orderType: 'senior', poses: [jpg] });
    expect(thumb.addon.id).toBe('ann');
    expect(thumb.pose).toBeNull();
    expect(thumb.src).toBe('https://cdn/ann.png');
  });

  it('composites through the CALLER\'s drawability test, so a self-drawing design with no product photo is pictured', () => {
    const gradMagnet = addon('gm', 'magnets', { cssName: 'gradmagnet', imageUrl: '/images/original/missing.png', giftRenderable: true });
    const cup = addon('cup', 'gifts', { giftRenderable: true });
    const offer = { couponType: 'FREE_ADDON_CHOICE', freeAddons: [cup, gradMagnet] };
    const canComposite = (a) => !!a.giftRenderable;
    // Senior shelf: gifts before magnets, so the cup leads either way...
    expect(freeItemThumbnail(offer, { orderType: 'senior', poses: [png], canComposite }).addon.id).toBe('cup');
    // ...but with only the grad magnet in the set it is drawn, where "has art" alone would have refused it.
    const only = { ...offer, freeAddons: [gradMagnet] };
    expect(freeItemThumbnail(only, { poses: [png], canComposite }).addon.id).toBe('gm');
    expect(freeItemThumbnail(only, { poses: [png] })).toBeNull();
  });

  it('never pictures a design the caller cannot draw, even when it is the most popular', () => {
    const unknown = addon('ann', 'announcements', { cssName: 'T810', giftRenderable: false });
    const cup = addon('cup', 'gifts', { giftRenderable: true });
    const offer = { couponType: 'FREE_ADDON_CHOICE', freeAddons: [unknown, cup] };
    const thumb = freeItemThumbnail(offer, { orderType: 'senior', poses: [png], canComposite: (a) => !!a.giftRenderable });
    expect(thumb.addon.id).toBe('cup');
    expect(thumb.pose).toBe(png);
  });

  it('never mutates the offer\'s set', () => {
    const before = set.freeAddons.map((a) => a.id);
    freeItemThumbnail(set, { orderType: 'senior', poses: [png] });
    expect(set.freeAddons.map((a) => a.id)).toEqual(before);
  });
});
